import { motion } from "framer-motion";
import { Star } from "lucide-react";

const testimonials = [
  { name: "Rizky Pratama", role: "Content Creator TikTok", photo: "https://images.unsplash.com/photo-1526218769555-7a8cced31a78?crop=entropy&cs=srgb&fm=jpg&q=85&w=200", text: "Asli worth it banget sih ini. Baru bayar langsung dikirim akunnya lewat WA, gak pake lama. Watermark ilang, export 4K lancar jaya!" },
  { name: "Salsabila Putri", role: "Editor Freelance", photo: "https://images.unsplash.com/photo-1562904403-a5106bef8319?crop=entropy&cs=srgb&fm=jpg&q=85&w=200", text: "Gila sih dapet harga segini fitur pro kebuka semua. Template premium sama AI tools nya kepake banget buat orderan klien. Auto langganan tiap bulan!" },
  { name: "Andika Saputra", role: "Mahasiswa & Videografer", img: 53, text: "Awalnya ragu, eh ternyata beneran instan prosesnya. Project lama gue juga tetep aman, muncul lagi pas sync. Recommended parah!" },
  { name: "Nadia Rahma", role: "Selebgram", img: 44, text: "Sumpah ini murah bangettt dibanding langganan resmi. Bisa dipake di laptop juga, editing reels jadi makin gampang. Sellernya fast respon pula!" },
];

export const CapCutTestimonials = () => (
  <section className="py-24 bg-white" id="capcut-testimoni">
    <div className="max-w-6xl mx-auto px-6 sm:px-8">
      <motion.h2
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="font-capcut-heading text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-slate-900 text-center mb-14"
      >
        Kata mereka yang udah <span className="text-blue-600">gas duluan</span>.
      </motion.h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {testimonials.map((t, i) => (
          <motion.div
            key={t.name}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.55, delay: (i % 2) * 0.1, ease: [0.22, 1, 0.36, 1] }}
            className="rounded-2xl bg-white border border-slate-200 p-7 shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:shadow-[0_20px_40px_rgb(37,99,235,0.1)] hover:-translate-y-1 transition-[transform,box-shadow] duration-300"
            data-testid={`capcut-testimonial-${i}`}
          >
            <div className="flex gap-0.5 mb-4">
              {[...Array(5)].map((_, s) => (
                <Star key={s} className="w-4 h-4 fill-amber-400 text-amber-400" />
              ))}
            </div>
            <p className="text-slate-700 text-sm md:text-base leading-relaxed">"{t.text}"</p>
            <div className="flex items-center gap-3 mt-6">
              <img
                src={t.photo || `https://i.pravatar.cc/80?img=${t.img}`}
                alt={t.name}
                width="44"
                height="44"
                loading="lazy"
                decoding="async"
                className="w-11 h-11 rounded-full object-cover"
              />
              <div>
                <p className="font-bold text-slate-900 text-sm">{t.name}</p>
                <p className="text-xs text-slate-500">{t.role}</p>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
